<app-layout-header></app-layout-header>

<router-outlet (activate)="onActivate($event)"></router-outlet>

<app-layout-footer></app-layout-footer>
